export default "__VITE_ASSET__DUbqrYQq__"